// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"TextContainer_textContainer__HWzYK"};